module.exports = __webpack_public_path__ + "img/14brsjb_04.42a26600.jpg";